import { create } from 'zustand';

const initialState = {
  questionsPerModule: [],
};
/** 
questionsPerModule = [
    {
        "module_uuid": "",
        "status": "",
        "msg": "",
        "questions": []
    }
]
*/
const initialGlobalList = {
  pendingQuestionsByModule: [],
};
/**  pendingQuestionsByModule = [ "module_uuid", "...", "..."] */

const initialModuleWithAI = {
  moduleWithAI: {},
};
/** 
moduleWithAI = {
  "module_uuid": "",
  "with_ai": false,
}

*/

export const useModuleAssessmentsAIStore = create((set, get) => ({
  ...initialState,
  ...initialGlobalList,
  ...initialModuleWithAI,
  setQuestions: (data = {}) =>
    set((state) => {
      const existingIndex = state.questionsPerModule.findIndex(
        (item) => item.module_uuid === data.module_uuid
      );

      if (existingIndex !== -1) {
        // Actualizar si ya existe
        const updatedQuestions = [...state.questionsPerModule];
        updatedQuestions[existingIndex] = {
          ...updatedQuestions[existingIndex],
          ...data,
        };
        return { questionsPerModule: updatedQuestions };
      } else {
        // Agregar si no existe
        return {
          questionsPerModule: [...state.questionsPerModule, data],
        };
      }
    }),
  removeQuestion: (id /** Remover cuando ya se hayan guardado las preguntas generadas con IA */) =>
    set((state) => ({
      questionsPerModule: state.questionsPerModule.filter((item) => item.module_uuid !== id),
    })),
  addItemToList: (item) =>
    set((state) => ({ pendingQuestionsByModule: [...state.pendingQuestionsByModule, item] })),
  removeItemFromList: (itemId) =>
    set((state) => ({
      pendingQuestionsByModule: state.pendingQuestionsByModule.filter(
        (item) => item?.id !== itemId
      ),
    })),
  setModuleWithAI: (moduleWithAI = {}) => set(() => ({ moduleWithAI })),
  reset: () => {
    set(initialState);
  },
  resetList: () => {
    /**devolver al estado inicial cuando se finaliza la sesion, en caso de que el usuario cierre la sesión*/
    set(initialGlobalList);
  },
}));
